import { getStripeCardDisplayName, type PaymentType } from '#src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../formContext/formData';
import { useTracking } from '../useTracking';

export function useTrackModelSuccess(): (params: { paymentType: PaymentType; cardType?: string }) => void {
	// usingSavedPaymentMethod is always false in PSF (not supported)
	const usingSavedPaymentMethod = false;

	const {
		// bandits and comboBanditData are not available in formData - use undefined
		user: { savedPaymentMethods },
		featureConfigs: { useDonationLanguage },
	} = usePromoteFormData();

	const { trackModelSuccess: trackModelSuccessInternal } = useTracking();

	return function trackModelSuccess({ paymentType, cardType }) {
		const cardBrand = getStripeCardDisplayName(cardType, savedPaymentMethods, usingSavedPaymentMethod, paymentType);

		trackModelSuccessInternal({
			paymentType,
			cardBrand,
			// bandits not available - pass undefined
			// comboBanditVariant: undefined,
			// comboBanditValue: undefined,
			// promotedBanditValueShown: undefined,
			foundationDonation: useDonationLanguage,
		});
	};
}
